import { Divider, MenuItem, SwipeableDrawer, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import ManageOffer from './ManageOffer';

const DiscusAgent = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9182 1.71376C11.0141 1.41437 10.0298 1.25 9 1.25C4.58172 1.25 1 4.27594 1 8.00862C1 9.46604 1.54603 10.8157 2.4747 11.9196L1.5 16.5L5.41607 14.0527C6.49418 14.5099 7.71152 14.7672 9 14.7672C13.4183 14.7672 17 11.7413 17 8.00862C17 7.32386 16.8795 6.66288 16.6553 6.04001"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 1V5"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 3H13"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Offer = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33233 7.80887L5.33168 7.82033C5.28733 8.5971 5.72244 9.32479 6.44047 9.67366L6.44784 9.67726C6.70098 9.79835 6.90847 9.99798 7.03938 10.2462L7.04232 10.2516C7.40412 10.9405 8.15242 11.3581 8.95015 11.3162L8.96226 11.3156C9.25156 11.2994 9.53874 11.374 9.78354 11.5291C10.459 11.9516 11.3165 11.9516 11.992 11.5291C12.2368 11.374 12.5239 11.2994 12.8133 11.3156L12.8254 11.3162C13.6218 11.3584 14.3711 10.9405 14.7337 10.2505L14.7355 10.2467C14.8669 9.99782 15.0749 9.79786 15.3288 9.67661L15.3347 9.67366C16.0527 9.32463 16.488 8.5971 16.4435 7.82016L16.4428 7.80936C16.4281 7.53576 16.504 7.26495 16.6592 7.03897C17.1057 6.3877 17.1057 5.52894 16.6593 4.87751C16.5044 4.65169 16.4281 4.38104 16.4428 4.10744L16.4435 4.09599C16.488 3.31905 16.0527 2.59152 15.3341 2.24233L15.3275 2.23905C15.0749 2.11829 14.8679 1.91964 14.7368 1.67206L14.733 1.66469C14.3711 0.975788 13.6218 0.558355 12.8254 0.600082L12.8131 0.600736C12.5239 0.616936 12.2368 0.542319 11.9921 0.387192H11.9918C11.3163 -0.0353141 10.4589 -0.0353141 9.78338 0.387192C9.53858 0.542155 9.2514 0.616773 8.96209 0.600573L8.94998 0.599918C8.15341 0.5577 7.40428 0.975625 7.04249 1.66437L7.0397 1.66944C6.90863 1.91816 6.70098 2.11796 6.44751 2.23922L6.44064 2.24249C5.7226 2.59136 5.28733 3.31905 5.33184 4.09599L5.3325 4.10679C5.34722 4.38038 5.2713 4.6512 5.11617 4.87702C4.66961 5.52845 4.66961 6.38737 5.11617 7.03864C5.27113 7.26446 5.34722 7.53527 5.33233 7.80887ZM5.66779 5.25763C5.90718 4.90909 6.02451 4.49117 6.0016 4.06899L6.00095 4.05753C5.97738 3.54274 6.26636 3.06459 6.73289 2.84581L6.73862 2.84303C7.12136 2.65976 7.43472 2.35802 7.63239 1.98264L7.63566 1.97642C7.87604 1.51857 8.37955 1.24104 8.91431 1.26951L8.92609 1.27C9.354 1.29406 9.77863 1.18377 10.1406 0.954352C10.5976 0.668481 11.1776 0.668481 11.6346 0.954352C11.9965 1.18344 12.4212 1.2939 12.8489 1.27017L12.8607 1.26951C13.3981 1.24137 13.8991 1.51857 14.1389 1.97511L14.1433 1.98345C14.341 2.35834 14.654 2.6596 15.0362 2.8427L15.0418 2.84549C15.5157 3.07588 15.8034 3.55157 15.7744 4.0577L15.7737 4.06964C15.7508 4.49182 15.8683 4.90958 16.1077 5.25812C16.397 5.68014 16.3969 6.2365 16.1074 6.65835C15.8682 7.00706 15.7508 7.42498 15.7737 7.84716L15.7744 7.85845C15.8034 8.36458 15.5157 8.84043 15.0416 9.07099L15.0367 9.07328C14.6537 9.25688 14.34 9.55895 14.1421 9.93499L14.1397 9.93989C13.8991 10.3977 13.3964 10.6754 12.8609 10.6468L12.8492 10.6461C12.4213 10.6223 11.9965 10.7327 11.6344 10.962C11.1776 11.2477 10.5976 11.2477 10.1408 10.962C9.81152 10.7533 9.4296 10.6427 9.03982 10.643C9.00202 10.643 8.96406 10.644 8.92609 10.6461L8.91431 10.6466C8.38659 10.6802 7.88734 10.404 7.63517 9.93908L7.63174 9.93269C7.43439 9.55797 7.12152 9.25688 6.73943 9.07377L6.73322 9.07066C6.25916 8.84027 5.97149 8.36441 6.00062 7.85845L6.00127 7.84651C6.02402 7.42433 5.90653 7.0064 5.66729 6.65802C5.37815 6.23601 5.37831 5.67965 5.66779 5.25796V5.25763Z"
        fill="#FFFFFF"
      />
      <path
        d="M12.5512 7.05174C12.5512 7.31841 12.4846 7.56908 12.3512 7.80374C12.2232 8.03841 12.0312 8.23574 11.7752 8.39574C11.5246 8.55574 11.2259 8.65174 10.8792 8.68374V9.33174H10.3592V8.68374C9.85789 8.63574 9.45255 8.47841 9.14322 8.21174C8.83389 7.94508 8.67922 7.59308 8.67922 7.15574H9.65522C9.67122 7.36374 9.73789 7.53708 9.85522 7.67574C9.97255 7.80908 10.1406 7.89441 10.3592 7.93174V6.17174C10.0019 6.08108 9.71122 5.99041 9.48722 5.89974C9.26322 5.80374 9.07122 5.65441 8.91122 5.45174C8.75655 5.24908 8.67922 4.97174 8.67922 4.61974C8.67922 4.17708 8.83389 3.81174 9.14322 3.52374C9.45255 3.23041 9.85789 3.05974 10.3592 3.01174V2.36374H10.8792V3.01174C11.3486 3.05441 11.7246 3.20374 12.0072 3.45974C12.2952 3.71041 12.4579 4.05708 12.4952 4.49974H11.5192C11.5032 4.33441 11.4392 4.18774 11.3272 4.05974C11.2152 3.92641 11.0659 3.83574 10.8792 3.78774V5.51574C11.2366 5.60108 11.5272 5.69174 11.7512 5.78774C11.9752 5.87841 12.1646 6.02508 12.3192 6.22774C12.4739 6.42508 12.5512 6.69974 12.5512 7.05174ZM9.60722 4.57174C9.60722 4.79041 9.67122 4.96108 9.79922 5.08374C9.93255 5.20641 10.1192 5.30508 10.3592 5.37974V3.76374C10.1299 3.79041 9.94589 3.87308 9.80722 4.01174C9.67389 4.15041 9.60722 4.33708 9.60722 4.57174ZM10.8792 7.93174C11.1139 7.89441 11.2979 7.80108 11.4312 7.65174C11.5646 7.49708 11.6312 7.31308 11.6312 7.09974C11.6312 6.88641 11.5646 6.72108 11.4312 6.60374C11.3032 6.48108 11.1192 6.38241 10.8792 6.30774V7.93174Z"
        fill="#FFFFFF"
      />
      <path
        d="M17.9565 13.1953C17.5127 12.4077 16.5286 12.1078 15.7211 12.5139L13.0959 13.7543C12.7334 13.0803 12.0381 12.6512 11.273 12.6296L8.84953 12.5629C8.4658 12.5519 8.08928 12.4545 7.7481 12.2785L7.5015 12.1507C6.23889 11.4925 4.73394 11.4942 3.47263 12.1549L3.48802 11.5963C3.49309 11.4112 3.34729 11.2571 3.16222 11.252L0.50478 11.1788C0.319708 11.1738 0.165727 11.3196 0.160655 11.5046L0.000128454 17.3364C-0.00494426 17.5215 0.140855 17.6757 0.325926 17.6807L2.98336 17.7539H2.99269C3.17416 17.7537 3.32258 17.6092 3.32765 17.4279L3.33518 17.1489L4.02556 16.7793C4.29654 16.6335 4.6135 16.5988 4.90952 16.6825L9.03198 17.8396C9.03918 17.8417 9.04638 17.8434 9.05374 17.845C9.35172 17.9074 9.65543 17.9386 9.95996 17.9385C10.6047 17.9388 11.2419 17.7999 11.8279 17.5308C11.8423 17.5243 11.8562 17.5168 11.8694 17.5083L17.8467 13.6417C17.9958 13.5455 18.0439 13.3496 17.9565 13.1953ZM0.679379 17.0198L0.821414 11.8583L2.80893 11.9129L2.66673 17.0746L0.679379 17.0198ZM11.5258 16.9319C10.7978 17.2605 9.98467 17.3512 9.20216 17.1911L5.09066 16.0373C4.62806 15.9064 4.13258 15.9608 3.70925 16.1884L3.35645 16.3772L3.45103 12.9453C4.56883 12.2017 6.0026 12.1253 7.19321 12.7456L7.43981 12.8734C7.87082 13.096 8.34635 13.2189 8.8312 13.2328L11.2546 13.2996C11.9354 13.319 12.5135 13.8037 12.6516 14.4707L9.0418 14.3714C8.85673 14.3663 8.70275 14.5121 8.69767 14.6972C8.6926 14.8822 8.8384 15.0364 9.02347 15.0415L13.0072 15.1511H13.0167C13.198 15.1509 13.3464 15.0064 13.3515 14.8251C13.3556 14.6795 13.3446 14.5337 13.3191 14.3903L16.0112 13.1181L16.019 13.1143C16.401 12.9209 16.8629 12.9855 17.1769 13.2763L11.5258 16.9319Z"
        fill="#FFFFFF"
      />
    </svg>
  );
};
const NeedHelp = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 17.7085V17.7189"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5013 14.0627C12.4821 13.7246 12.5733 13.3893 12.7612 13.1075C12.9491 12.8257 13.2235 12.6126 13.543 12.5002C13.9345 12.3505 14.2859 12.1119 14.5696 11.8033C14.8533 11.4947 15.0614 11.1244 15.1777 10.7217C15.2939 10.3189 15.3151 9.89468 15.2396 9.48236C15.164 9.07004 14.9938 8.68089 14.7423 8.34554C14.4907 8.01019 14.1648 7.7378 13.7901 7.54982C13.4155 7.36183 13.0023 7.26338 12.5831 7.26222C12.1639 7.26105 11.7502 7.35721 11.3745 7.54312C10.9988 7.72902 10.6713 7.9996 10.418 8.33355"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ViewAllOff = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16602 5H16.666"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16602 10H16.666"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 15H16.6667"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33398 13.3327C3.33398 12.8907 3.50958 12.4667 3.82214 12.1542C4.1347 11.8416 4.55862 11.666 5.00065 11.666C5.44268 11.666 5.8666 11.8416 6.17916 12.1542C6.49172 12.4667 6.66732 12.8907 6.66732 13.3327C6.66732 13.8252 6.25065 14.166 5.83398 14.5827L3.33398 16.666H6.66732"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.00065 8.33398V3.33398L3.33398 5.00065"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
function VendorSelectMenuDrawer(props) {
  const {
    row,
    discussBuyerAgent,
    manageOfferClick,
    openhistorydialog,
    manageOffer,
    buyerId,
    setItemObj,
    setVendorAction,
    setCounterOfferDialog,
    getListInfo,
    manageOfferClickClose,
    acceptLog,
    vendorDatas,
    vendorside,
    setOpenhistorydialog,
    setManageOffer,
    tableData,
    open,
    setDrawerOpen,
    setIsSwalOpen,
    setVendorGeneratePdf,
  } = props;
  const history = useHistory();
  return (
    <SwipeableDrawer
      open={open}
      anchor="bottom"
      onClose={() => {
        setDrawerOpen((prev) => !prev);
      }}
      PaperProps={{
        sx: {
          backgroundColor: '#3C3C3C',
          borderRadius: '8px 8px 0 0',
          maxHeight: 'auto',
          overflowY: 'auto',
        },
      }}
      style={{ zIndex: '100000' }}
    >
      <MenuItem value={20}>
        <Typography
          sx={{
            fontFamily: 'Poppins!important',
            fontWeight: 400,
            fontSize: '12px',
            color: '#8E8A8A',
            lineHeight: 'normal',
            fontStyle: 'normal',
          }}
        >
          - Offer Status Action -
        </Typography>
      </MenuItem>
      <MenuItem
        value={20}
        disabled={
          row?.buyerOfferDetails?.offerUniqueId == undefined ? true : false
        }
        onClick={() => {
          discussBuyerAgent(row);
          setDrawerOpen(false);
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins!important',
            fontWeight: 300,
            fontSize: '14px',
            color: '#FFFFFF',
            fontStyle: 'normal',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <DiscusAgent /> Discuss with Agent
        </Typography>
      </MenuItem>
      <Divider />
      <MenuItem
        value={20}
        onClick={() => {
          manageOfferClick();
          setDrawerOpen(false);
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins!important',
            fontWeight: 300,
            fontSize: '14px',
            color: '#FFFFFF',
            fontStyle: 'normal',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Offer /> Manage Offer
        </Typography>
      </MenuItem>
      {(manageOffer || openhistorydialog) && (
        <ManageOffer
          acceptLog={acceptLog}
          open={manageOffer}
          onClose={manageOfferClickClose}
          getListInfo={getListInfo}
          row={row}
          setCounterOfferDialog={setCounterOfferDialog}
          setVendorAction={setVendorAction}
          setItemObj={setItemObj}
          buyerId={buyerId}
          tableData={tableData}
          moxouserId={true}
          setManageOffer={setManageOffer}
          setOpenhistorydialog={setOpenhistorydialog}
          vendorside={vendorside}
          vendorDatas={vendorDatas}
          setIsSwalOpen={setIsSwalOpen}
          setVendorGeneratePdf={setVendorGeneratePdf}
        />
      )}

      <MenuItem
        value={20}
        disabled={true}
        onClick={() => {
          setDrawerOpen(false);
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins!important',
            fontWeight: 300,
            fontSize: '14px',
            color: '#FFFFFF',
            fontStyle: 'normal',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <ViewAllOff /> View All Offers
        </Typography>
      </MenuItem>

      <Divider />
      <MenuItem
        value={20}
        onClick={() => {
          setDrawerOpen(false);
          history.push('/helpcentre');
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins!important',
            fontWeight: 300,
            fontSize: '14px',
            color: '#FFFFFF',
            fontStyle: 'normal',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <NeedHelp /> Need Help
        </Typography>
      </MenuItem>
    </SwipeableDrawer>
  );
}

export default VendorSelectMenuDrawer;
